import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    wrap: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    }
}))

export {
    useStyles
}